module.exports = __webpack_public_path__ + "static/media/poster_3.fa1c1ca8.png";